const slick = require('slick-carousel');
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Equalizer from "../../../../scripts/classes/Equalizer";
import PubSub from 'underpub-js';

var QuoteSlider = function(options) {

	this.options = {
		$el: false,
	};

	this.data = {
		baseClass: 'comp-QuoteSlider',
	};

	$.extend(true, this.options, options);

};

/**
* Init'ing our events
* @return {[type]} [description]
*/
QuoteSlider.prototype.init = function() {

	var self = this;

	self.$quoteSlider = self.options.$el.find(`.quote-slider`);

	self.$quoteSlider.slick({
		speed: 350,
		slidesToShow: 1,
		infinite: true,
		arrows: false,
		dots: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 8000,
	});

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideEq = new Equalizer( self.options.$el.find(`.quote-slide-outer-content-wrapper`) );

	this.slideEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.slideEq.equalizeHeights();
	});

	self.options.$el.find(`.dots-nav .dot`).on('click', function() {

		self.options.$el.find(`.dots-nav .dot`).removeClass('active');
		$(this).addClass('active');

		var slideNumber = $(this).data('slideNumber');

		self.$quoteSlider.slick('slickGoTo', slideNumber - 1);

	});

	this.$quoteSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

		self.options.$el.find(`.dots-nav .dot`).removeClass('active');
		self.options.$el.find(`[data-slide-number="${nextSlide+1}"]`).addClass('active');

	});

};

export default QuoteSlider;
